import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=5237d570&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=5237d570&prod&scoped=true&lang=css"
import style1 from "./settings.vue?vue&type=style&index=1&id=5237d570&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237d570",
  null
  
)

export default component.exports